import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { Hero } from "@/components/sections/Hero";
import { Manifesto } from "@/components/sections/Manifesto";
import { Team } from "@/components/sections/Team";
import { Materials } from "@/components/sections/Materials";
import { SupplyChain } from "@/components/sections/SupplyChain";
import { Partners } from "@/components/sections/Partners";
import { Warehouses } from "@/components/sections/Warehouses";
import { VideoSection } from "@/components/sections/VideoSection";
import { BlogPreview } from "@/components/sections/BlogPreview";
import { Contact } from "@/components/sections/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Team />
        <Materials />
        <SupplyChain />
        <Partners />
        <Warehouses />
        <VideoSection />
        <BlogPreview />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
